export default "__VITE_ASSET__d5571cac__"